module.exports = __webpack_public_path__ + "static/img/cs-board.7754d82.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/20250724/ruanjian/cs-board.svg
// module id = WqHF
// module chunks = 20